import { render, staticRenderFns } from "./SemenStationPage.vue?vue&type=template&id=73617fe8&scoped=true&"
import script from "./SemenStationPage.vue?vue&type=script&lang=js&"
export * from "./SemenStationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73617fe8",
  null
  
)

export default component.exports